// Whether the app is running on the development host. All deployed servers
// build the same production bundle, so this is a runtime hostname check rather
// than a build-time flag. Used to show NXPlan "Visit" affordances only on dev.
export function isDevHost() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return host === "localhost" || host.startsWith("dev.");
}
